document.addEventListener('DOMContentLoaded', () => {
    const faqHeadings = document.querySelectorAll('.faq-heading');
    const faqItems = document.querySelectorAll('.faq-categories-item');
  
    faqHeadings.forEach((heading, index) => {
      const currentId = heading.id;
      let count = 0;
      let nextSibling = heading.nextElementSibling;
  
      // Count all accordion elements until the next heading appears
      while (nextSibling && !nextSibling.classList.contains('faq-heading')) {
        if (nextSibling.classList.contains('accordion')) {
          count++;
        }
        nextSibling = nextSibling.nextElementSibling;
      }
  
      // Insert the count into the matching sidebar .faq-count
      const matchingSidebarItem = document.querySelector(`.faq-categories-item a[href="#${currentId}"] .faq-count`);
      if (matchingSidebarItem) {
        matchingSidebarItem.textContent = `(${count})`;
      }
    });
  });
  